module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-facility-0d80077bde8255c0a212a16360e2c5d9.svg";